import React from "react";
import MobileHeader from "./Header";
import { Box, Typography, useTheme } from "@mui/material";
import NotifStatusIcon from "../../../../media/images/icons/notif-status";
import CustomTopTabbar from "../../../components/CustomTopTabbar";
import TopTabbar from "./TopTabbar";

export default function NotifsPage() {
  const theme = useTheme();

  return (
    <>
      <MobileHeader />
      <Box
        sx={{
          // border: "1px solid gray",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "4px",
          padding: "8px",
        }}
      >
        <NotifStatusIcon size={23} color={theme.palette.secondary.main} />

        <Typography
          sx={{
            fontWeight: "600",
          }}
        >
          شما
          <Typography
            sx={{
              fontWeight: "600",
            }}
            component="span"
            color="secondary.main"
          >
            {" 15 اعلان جدید "}
          </Typography>
          دارید
        </Typography>
      </Box>
      <TopTabbar />
    </>
  );
}
